Controller.$inject = ['$timeout'];

function Controller($timeout) {
    const self = this;
    self.multi = false;

    self.onModelChange = ($event) => {
        $timeout(() => {
            self.onChange({$event});
        }, 0);
    };

    self.$postLink = () => {
        self.parent = document.querySelector('.hui-input-selector-container');
        self.multi = self.parent.getAttribute('multi') === 'true';
    };
}

export function HuiInputSelectorItem() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            disabled: '<',
            hName: '@',
            ngModel: '=',
            ngValue: '<',
            shape: '@',
            sizing: '@',
            onModelChange: '&',
            onChange: '&'
        },
        controller: Controller,
        controllerAs: '$huiSelectorItemCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-input-selector-item" 
                        ng-class="[
                           {
                            'selected': $huiSelectorItemCtrl.multi ? $huiSelectorItemCtrl.ngModel : ($huiSelectorItemCtrl.ngModel === $huiSelectorItemCtrl.ngValue),
                            'circle': $huiSelectorItemCtrl.shape === 'circle'
                            },
                             $huiSelectorItemCtrl.sizing || 'md'
                        ]"
                        role="$huiSelectorItemCtrl.multi ? 'checkbox' : 'radio'"
                        tabindex="$huiSelectorItemCtrl.disabled ? -1 : 0"
                        aria-checked="{{ $huiSelectorItemCtrl.multi ? ($huiSelectorItemCtrl.ngModel) : ($huiSelectorItemCtrl.ngModel === $huiSelectorItemCtrl.ngValue ? true : false)}}"
                        aria-disabled="$huiSelectorItemCtrl.disabled"
                        >
                        <label ng-class="{'disabled': $huiSelectorItemCtrl.disabled}">
                            <input 
                                ng-if="$huiSelectorItemCtrl.multi"
                                type="checkbox"
                                name="{{$huiSelectorItemCtrl.hName}}"
                                ng-disabled="$huiSelectorItemCtrl.disabled"
                                ng-value="$huiSelectorItemCtrl.ngValue"
                                ng-model="$huiSelectorItemCtrl.ngModel"
                                ng-change="$huiSelectorItemCtrl.onModelChange($event)">
                            <input 
                                ng-if="!$huiSelectorItemCtrl.multi"
                                type="radio"
                                name="{{$huiSelectorItemCtrl.hName}}"
                                ng-disabled="$huiSelectorItemCtrl.disabled"
                                ng-value="$huiSelectorItemCtrl.ngValue"
                                ng-model="$huiSelectorItemCtrl.ngModel"
                                ng-change="$huiSelectorItemCtrl.onModelChange($event)">
                            <span class="d-inline-flex align-items-center gap-1"
                                  ng-class="{'empty-space': $huiSelectorItemCtrl.multi ? (!$huiSelectorItemCtrl.ngModel) : ($huiSelectorItemCtrl.ngModel === $huiSelectorItemCtrl.ngValue ? false : true)}">
                                <i ng-show="$huiSelectorItemCtrl.multi && $huiSelectorItemCtrl.shape === 'rectangle' && ($huiSelectorItemCtrl.multi ? ($huiSelectorItemCtrl.ngModel) : ($huiSelectorItemCtrl.ngModel === $huiSelectorItemCtrl.ngValue ? true : false))" class="fa-solid fa-check checked-icon" 
                                   ng-class="{'checked': $huiSelectorItemCtrl.multi ? ($huiSelectorItemCtrl.ngModel) : ($huiSelectorItemCtrl.ngModel === $huiSelectorItemCtrl.ngValue ? true : false)}"></i>
                                <ng-transclude></ng-transclude>
                            </span>
                        </label>
                    </div>
            `;
        }
    };
}
